import { HTMLAttributes, forwardRef, useState } from 'react';
import { JoveFileDragUploadFilesView, JoveLogoLoading } from '@jove-frontend/mui';
import type { CommonUploadFilesItemProp } from '@jove-frontend/mui';
import { REQUEST_SUCCESS_CODE, apiCreateQuoteByUploadApplicationFormFile, useLocalTranslation } from '@jove-frontend/uikit';
import { CloudUploadOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import toast from 'react-hot-toast';

type UploadApplicationFormQuoteFileProps = HTMLAttributes<HTMLDivElement> & {
  success?: (info: { id: string }) => void;
  extraParams?: {
    productId?: string;
  };
  uploadingFile?: (loading: boolean) => void;
};

const MAX_UPLOAD_FILE_COUNT = 1;

const UploadApplicationFormQuoteFile = forwardRef((props: UploadApplicationFormQuoteFileProps, ref) => {
  const { success, extraParams, uploadingFile } = props;
  const { $t } = useLocalTranslation();
  const [loading, setLoading] = useState(false);

  /**
   * requests
   */
  const requestCreateQuote = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    setLoading(true);
    uploadingFile?.(true);
    const [res] = await apiCreateQuoteByUploadApplicationFormFile({ formData, ...extraParams });
    setLoading(false);
    uploadingFile?.(false);

    if (res?.code === REQUEST_SUCCESS_CODE) {
      success?.({
        id: res?.data?.quote_id,
        ...res?.data,
      });
    }
  };

  /**
   * methods
   */
  const selectFilesAction = (files: CommonUploadFilesItemProp[]) => {
    if (files?.[0]) {
      requestCreateQuote(files[0].file);
    }
  };

  return (
    <Box className="relative flex min-h-[240px] flex-col space-y-3">
      {loading && <JoveLogoLoading label={$t('page:quotes.creating_quote_from_application_form')} />}
      <JoveFileDragUploadFilesView
        className="w-full px-6 py-8"
        maxFiles={MAX_UPLOAD_FILE_COUNT}
        selectFiles={selectFilesAction}
        emitError={({ msg }) => toast.error(msg)}
        descList={[$t('page:quotes.drag_drop_or_click_to_upload_pdf')]}
        fileAccept={['application/pdf']}
        imgSlot={<CloudUploadOutlined className="h-12 w-12 text-gray-400" />}
      />
    </Box>
  );
});

export default UploadApplicationFormQuoteFile;
